import OfferDetailHeader from './OfferDetailHeader';

export default OfferDetailHeader;
